
import { Comment } from './types/comment';
import PostView from './post/PostView';
import { useSubscriptionStatus } from '@/hooks/useSubscriptionStatus';
import { SubscriptionLock } from '@/components/subscription/SubscriptionLock';

interface CommentDetailProps {
  comment: Comment | null;
}

const CommentDetail = ({ comment }: CommentDetailProps) => {
  const { isSubscriptionActive, isLoading } = useSubscriptionStatus();
  
  if (!comment) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-6 bg-gray-50 dark:bg-[#1e1e2d]">
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-500 dark:text-gray-400">
            Sélectionnez un commentaire pour afficher les détails
          </h3>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-500">
            Cliquez sur un commentaire dans la liste pour voir son contenu
          </p>
        </div>
      </div>
    );
  }

  // Pendant le chargement, renvoyez une version simplifiée au lieu d'un indicateur de chargement 
  // pour éviter le flash
  if (isLoading) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center p-6 bg-gray-50 dark:bg-[#1e1e2d]">
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-500 dark:text-gray-400">
            Chargement du contenu...
          </h3>
        </div>
      </div>
    );
  }

  if (!isSubscriptionActive) {
    return (
      <SubscriptionLock 
        title="Contenu verrouillé"
        description="Le contenu détaillé des commentaires n'est disponible qu'avec un abonnement actif."
        buttonText="Débloquer les commentaires"
      />
    );
  }

  return <PostView comment={comment} />;
};

export default CommentDetail;
